import * as fromState from './store/state.reducer';
import * as fromOrganization from './store/organization.reducer';
import * as fromCart from './store/cart.reducer';
import * as fromDiscounts from './store/discounts.reducer';
import * as fromUser from './store/user.reducer';
import { ActionReducerMap } from '@ngrx/store';


export interface AppState {
  state: fromState.State;
  organizationInfo: fromOrganization.IOrganizationState;
  cart: fromCart.ICartState;
  discounts: fromDiscounts.DiscountsState;
  user: fromUser.IUserState;
}

export const appReducer: ActionReducerMap<AppState> = {
  state: fromState.stateReducer,
  organizationInfo: fromOrganization.organizationReducer,
  cart: fromCart.cartReducer,
  user: fromUser.userReducer,
  discounts: fromDiscounts.discountsReducer
};
